import { render, staticRenderFns } from "./magiczoom.vue?vue&type=template&id=f81e2ce2&"
import script from "./magiczoom.vue?vue&type=script&lang=js&"
export * from "./magiczoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plenty24/3672/203/Bigtex5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f81e2ce2')) {
      api.createRecord('f81e2ce2', component.options)
    } else {
      api.reload('f81e2ce2', component.options)
    }
    module.hot.accept("./magiczoom.vue?vue&type=template&id=f81e2ce2&", function () {
      api.rerender('f81e2ce2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/bigtex/magiczoom.vue"
export default component.exports